export default (value: number, decimals = 1) => {
  const isDecimal = value - Math.trunc(value) !== 0

  return isDecimal ? Number(value.toFixed(decimals)) : value
}
